import Pagination from "@/components/Pagination";
import CustomLabel from "@/components/CustomLabel";
import CollapsePanel from "@/components/CollapsePanel";
import RedPrice from "@/components/RedPrice";

export default {
    install(Vue) {
        Vue.component("Pagination", Pagination);
        Vue.component("CustomLabel", CustomLabel);
        Vue.component("CollapsePanel", CollapsePanel);
        Vue.component("RedPrice", RedPrice);
    }
};



// WEBPACK FOOTER //
// ./src/plugins/globalCmp.js